import type { RevenueReport } from '@witmetrics/utils';
import { MONTHS_SHORT } from '@witmetrics/utils/constants';
import { formatNumber } from '@witmetrics/utils/strings';
import { getReportYear } from '@/utils/reports';
import BarChart, { type BarChartProps } from '@/charts/BarChart';
import { COMPARISON_BARS } from '@/charts/BarChart/constants';
import { buildComparisonBarStyle } from '@/charts/BarChart/utils';
import type { ReportData } from './types';
import { formatReport } from './utils';

export type AcceptedPatientsChartProps = {
  currentReport: RevenueReport;
  previousReport: RevenueReport;
  onMount?: () => void;
  onSelect?: (year: number, monthIndex: number) => void;
};

export default function AcceptedPatientsChart({
  currentReport,
  previousReport,
  onMount,
  onSelect,
}: AcceptedPatientsChartProps) {
  const data = formatReport(currentReport, previousReport);
  const currentYear = `${getReportYear(currentReport)}`;
  const previousYear = `${getReportYear(previousReport)}`;

  const handleSelect: BarChartProps<ReportData>['onSelect'] = (key, value) => {
    onSelect?.(parseInt(key as string), MONTHS_SHORT.indexOf(value.month));
  };

  return (
    <BarChart
      {...COMPARISON_BARS}
      {...buildComparisonBarStyle(['current', 'previous'])}
      height="100%"
      data={data}
      xAxis="month"
      series={[currentYear, previousYear]}
      formatValue={(value) => formatNumber(value, 0)}
      onMount={onMount}
      onSelect={handleSelect}
    />
  );
}
